import { BfPageStoreProvider, useStoreState } from '@tw/tw-runtime-react';
import { ProductTypeEnumValue, SaleOrderDTO } from '@tw/clvip-api-gen';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useState } from 'react';
import { TwCard, TwColumn, TwEmpty, TwIcon, TwImage, TwLoadingBlock, TwPage, TwRow } from '@tw/tw-components-rn';

import { BfAppContext } from '@tw/tw-runtime';
import { ElementUtils } from '@tw/tw-platform-react';
import { GiftCustomInfoNavigator } from '@/gift/stores/gift-custom-info/gift-custom-info-navigator';
import { MaterialIcons } from '@expo/vector-icons';
import { ROUTE_NAMES } from '@/app/navigation/route-names';
import { ScrollView } from 'react-native-gesture-handler';
import { SettingHistoryOrderStore } from '../../stores/history-order/setting-history-order-store';
import { Text } from 'react-native';
import { styles } from './styles';
import { usePageStoreLifecycle } from '@tw/tw-runtime-react';

const dayjs = require('dayjs');

export const SettingHistoryOrder = () => {
  const [store] = useState(() => new SettingHistoryOrderStore());
  usePageStoreLifecycle(store, undefined);
  const isLoading = useStoreState(store, (state) => state.isLoading);
  const data = useStoreState(store, (state) => state.data);

  if (isLoading) {
    return <TwLoadingBlock />;
  }
  if (!data?.length) {
    return (
      <>
        <TwPage.Header title={'历史订单'}></TwPage.Header>
        <TwEmpty description={'暂无订单'} />
      </>
    );
  }
  return (
    <BfPageStoreProvider store={store}>
      <TwPage translucentStatusBar={true}>
        <TwPage.Header title={'历史订单'}></TwPage.Header>
        <ScrollView style={styles.container}>
          <TwColumn space={4}>
            {data?.map((item: SaleOrderDTO, index) => {
              console.log('SaleOrderDTO', item);
              return (
                <TwCard
                  key={index}
                  style={styles.cardContainer}
                  onContentPress={() => {
                    //自选
                    if (item.productId.type.code === ProductTypeEnumValue.open_package) {
                      // console.log
                    } else {
                      GiftCustomInfoNavigator.start({
                        productId: item.productId.id,
                        orderId: item.id,
                        isOrder: true
                      });
                    }
                  }}
                  //卡片底部区域
                  footer={
                    <TwCard.ContentFooter>
                      <TwRow space={1} alignItems={'center'}>
                        <TwIcon icon={'icon-file-date'} size={12} color={'#8FBD69'}></TwIcon>
                        <Text style={styles.footerDesc}>{item.welfare.name}</Text>
                      </TwRow>
                      <Text style={styles.footerDesc}>{dayjs(item?.deliveryTime?.from).format('YYYY-M-D')}</Text>
                    </TwCard.ContentFooter>
                  }
                >
                  <TwCard.Content
                    content={
                      <>
                        <TwRow space={3}>
                          <TwImage
                            style={styles.image}
                            source={{
                              uri: item?.welfare?.pic?.url ?? 'https://wallpaperaccess.com/full/317501.jpg'
                            }}
                          />
                          <TwColumn space={3}>
                            <Text style={styles.contentText}>{item.productId.name}</Text>
                            <TwColumn>
                              <TwRow space={1} alignItems={'center'}>
                                <MaterialIcons name="storefront" size={16} color="#565656" />
                                <Text style={styles.contentDesc}>{item.productId.supplier.name}</Text>
                              </TwRow>
                              <TwRow space={1} alignItems={'center'}>
                                <TwIcon icon={'icon-location'} size={16} color="#565656"></TwIcon>
                                <Text style={styles.contentDesc}>
                                  {ElementUtils.getText(item.productId.supplier, {
                                    type: 'coordinates',
                                    id: 'address'
                                  })}
                                </Text>
                              </TwRow>
                            </TwColumn>
                          </TwColumn>
                        </TwRow>
                      </>
                    }
                  ></TwCard.Content>
                  <Text style={styles.divider}></Text>
                </TwCard>
              );
            })}
          </TwColumn>
        </ScrollView>
      </TwPage>
    </BfPageStoreProvider>
  );
};
